import PropTypes from 'prop-types';
import React, { useState, useCallback } from 'react';
import CustomizationForm from './CustomizationForm';
import { RichNextEditor } from 'lib/components/RichNextEditor';
import i18n from 'lib/utility/i18n';

const DashboardFlexibleAreaCustomization = ({ customization, account_id }) => {
  const [customizationState, setCustomizationState] = useState({
    ...customization,
    title: i18n.t('Learner Dashboard Customization'),
  });

  const contentChange = useCallback((content) => {
    setCustomizationState((prevState) => ({
      ...prevState,
      custom_content: content,
    }));
  }, []);

  const onUpdate = useCallback((updatedObj) => {
    setCustomizationState((prevState) => ({
      ...prevState,
      ...updatedObj,
    }));
  }, []);

  return (
    <div>
      <CustomizationForm
        object={customizationState}
        onUpdate={onUpdate}
        level="account"
      >
        <div className="m-b-10">
          <RichNextEditor
            initialValue={customizationState.custom_content}
            onChange={contentChange}
            shouldSanitize={true}
            editor="summernote"
            showImageUrlButton={true}
            summernoteProps={{ 
              accountId: account_id
            }}
          />
        </div>
      </CustomizationForm>
    </div>
  );
};

DashboardFlexibleAreaCustomization.propTypes = {
  customization: PropTypes.object.isRequired,
  account_id: PropTypes.string
};

export default DashboardFlexibleAreaCustomization;
